import React from 'react';
import { FaDownload } from 'react-icons/fa';
import css from './FileDownloadButton.module.css';

interface DownloadButtonProps {
  selectedCount: number;
  onDownload: () => void;
  selectedFiles?: string[];
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ 
  selectedCount, 
  onDownload,
  selectedFiles = []
}) => {
  const formatFileNames = (files: string[]) => {
    return files.map(file => 
      decodeURIComponent(file).replace(/REPLACINGSLASHES/g, '/')
    );
  };

  return (
    <button
      onClick={onDownload}
      className={css.downloadButton}
      disabled={selectedCount === 0}
      title={selectedFiles.length > 0 ? `Download: ${formatFileNames(selectedFiles).join(', ')}` : undefined}
    >
      <FaDownload className={css.downloadIcon} />
      Download Selected ({selectedCount})
    </button>
  );
};

export default DownloadButton;